'use strict';

window.$a_jQuery(function($) {
    
    // Функция, вызывающая runInit на обновления суммы
    function setupCartAmountObserver() {
        const rootNode = document.querySelector('body'); // либо более конкретный стабильный контейнер
        if (!rootNode) {
            console.warn('Root node not found');
            return;
        }

        let currentSubtotalNode = rootNode.querySelector('.cart__footer-subtotal .money');

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                // console.log('MutationObserver -- mutation.type =', mutation.type);

                if (mutation.type === 'childList') {
                    // Проверяем, был ли заменён элемент суммы
                    const newSubtotalNode = rootNode.querySelector('.cart__footer-subtotal .money');
                    if (newSubtotalNode !== currentSubtotalNode) {
                        currentSubtotalNode = newSubtotalNode;
                        console.log('Subtotal node replaced, running initCartPageFeatures(), runInit()');
                        initCartPageFeatures();
                        window.runInit();
                        break;
                    }
                }
                if (mutation.type === 'characterData') {
                    console.log('Text content changed, running initCartPageFeatures(), runInit()');
                    initCartPageFeatures();
                    window.runInit();
                    break;
                }
            }
        });

        observer.observe(rootNode, {
            childList: true,
            characterData: true,
            subtree: true
        });

        console.log('MutationObserver started');
    }

    // Функция, вызывающая ваши delivery функции, если они определены
    function initDeliveryFunctions() {
        if (typeof window.apiGetDataDeliveryFull === 'function') {
            window.apiGetDataDeliveryFull();
        } else {
            console.error('apiGetDataDeliveryFull not defined');
        }
        if (typeof window.apiGetDataDeliveryEarliest === 'function') {
            window.apiGetDataDeliveryEarliest();
        } else {
            console.error('apiGetDataDeliveryEarliest not defined');
        }
    }


    // Функция, вызывающая ваши delivery функции, если они определены
    function initDeliveryCartFunctions() {
        if (typeof window.apiGetDataDeliveryFull === 'function') {
            window.apiGetDataDeliveryFull();
        } else {
            console.error('apiGetDataDeliveryFull not defined');
        }
        if (typeof window.apiGetDataDeliveryEarliest === 'function') {
            window.apiGetDataDeliveryEarliest();
        } else {
            console.error('apiGetDataDeliveryEarliest not defined');
        }
        if (typeof window.loadCartTotalExcludingGiftCards === 'function') {
            window.loadCartTotalExcludingGiftCards(function(total, isGiftCardOnly){
                if (total !== null) {
                    console.log('Total amount of goods excluding gift cards:', total);
                    attilus_config.cart = {
                        totalPriceWithoutGiftCards: total,
                        giftCardOnly: isGiftCardOnly
                    };
                } else {
                    console.log('Unable to get total amount');
                }


                if (typeof window.updateDeliveryData === 'function') {
                    window.updateDeliveryData();
                } else {
                    console.error('updateDeliveryData not defined');
                }
                if (typeof window.datepickerInit === 'function' && window.$a_jQuery) {
                    window.datepickerInit();
                } else {
                    console.error('datepickerInit not defined');
                }
            });
        } else {
            console.error('loadCartTotalExcludingGiftCards not defined');

            if (typeof window.updateDeliveryData === 'function') {
                window.updateDeliveryData();
            } else {
                console.error('updateDeliveryData not defined');
            }
            if (typeof window.datepickerInit === 'function' && window.$a_jQuery) {
                window.datepickerInit();
            } else {
                console.error('datepickerInit not defined');
            }
        }

        initDeliveryCartDomInteractions ();
    }

    function initDeliveryCartDomInteractions() {
        $('[data-toggle="tooltip"]').tooltip();

        $('#accordion-1 .product-delivery-btn').on('click', function () {
            var target = '#' + $(this).attr('aria-controls');

            // Закрываем все блоки кроме целевого
            $('.product-delivery-data-card .collapse').not(target).collapse('hide');
            // Показываем целевой блок
            $(target).collapse('show');

            // Обработка классов active у кнопок
            $('#accordion-1 .product-delivery-btn').addClass('collapsed').attr('aria-expanded', 'false');
            $(this).removeClass('collapsed').attr('aria-expanded', 'true');
            
            window.updateDeliveryOptionBlock(target);
            window.updateDeliveryPrice($(target).data('delivery-option'));
        });
        
        $('.postcodeCheckBtn').click(function(e){
            if ($(this).hasClass('disabled')){return false;}
            window.apiGetDataDeliveryByPostcode($(this).parents('.input-group').find('.postcode-input').val());
        });

        var postcodeInput = $('.postcode-input');
        postcodeInput.on('keyup keypress', function(e, i){
            var checkPostCodeResult = checkPostCode($(this).val().trim());
            var keyCode = e.keyCode || e.which;
            var delivery_option = $(this).parents('.product-delivery-option');

            delivery_option.find('.input-time-group, .input-date-group').addClass('hidden');
            //// -> setDeliveryPrice
            // delivery_option.find('.delivery-option-price').addClass('hidden');

            ////
            var attribute_delivery_postcode = $('.attributes-delivery-postcode');
            var attribute_delivery_date = $('.attributes-delivery-date');
            var attribute_delivery_time = $('.attributes-delivery-time');
            attribute_delivery_postcode.val('');
            attribute_delivery_date.val('');
            attribute_delivery_time.data('time-from','').data('time-to','').val('');

            delivery_option.find('.delivery-date-attribute').val('');
            // delivery_option.find('.postcode-input').val('');
            delivery_option.find('.postcode-input-hidden').val('');
            delivery_option.find('.time-from-to').data('time-from-to', '')
                .data('time-from', '').data('time-to', '')
                .val('');

            delivery_option.find('.delivery-data-errors').addClass('hidden').data('fixed',0).data('errors',0);
            $('.date-input').data('error-date', 0).removeClass('error-date');
            ////

            if (checkPostCodeResult){
                postcodeInput.removeClass('error').css({color: 'inherit'}).val(checkPostCodeResult);
                postcodeInput.parents('.input-group').find('.postcodeCheckBtn, .postcodeJcbCheckBtn').removeClass('disabled');
                //window.apiGetDataDeliveryByPostcode(postcodeInput.val());

                if(keyCode === 13) {
                    $(this).parents('.input-group').find('.postcodeCheckBtn, .postcodeJcbCheckBtn').trigger('click');
                }
            } else {
                $(this).parents('.input-group').find('.postcodeCheckBtn, .postcodeJcbCheckBtn').addClass('disabled');
                delivery_option.find('.eligible ,.noteligible').addClass('hidden');
            }

            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
        postcodeInput.trigger('keypress');


        $('.courier-instruction-label').click(function (){
            var input = $('#' + $(this).prop('for'));
            input.parent('.input-group').removeClass('hidden');
            $(this).removeClass('as-link').find('.adding-label').removeClass('hidden');
            input.css({height: '8em', opacity: 1});
        });

        // delivery-place-custom-select
        var $deliveryPlaceSelect = $('.delivery-place-select');
        var $deliveryPlaceList = $('.delivery-place-list-hidden');

        if ($deliveryPlaceSelect.length && $deliveryPlaceList.length) {
            $deliveryPlaceSelect.deliveryplacecustomselect({
                deliveryPlaceList: $deliveryPlaceList,
                defaultCountryIndex: sessionStorage.getItem('selectedCountryIndex')
            });
        }
    }


    // // Обработка нажатия на кнопки +/-/Remove в корзине
    // $('.cart__container .quantity-input__button, .cart__container .cart__form-item-remove').on('click', function() {
    //     setTimeout(function (){
    //         console.log('do runInit()...')
    //         window.runInit();
    //     }, 5000)
    //
    // });



    // Запуск инициализации — ресолвится когда есть jQuery и DOM готов
    window.runInit = function() {
        if (attilus_config.current_template === 'product') {
            initDeliveryFunctions();
        } else if (attilus_config.current_template === 'cart') {
            initDeliveryCartFunctions();
        }
    };
   
    $("a.scroll-to").click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var section = $(this).attr("data-link");
        $("html, body").animate({
            scrollTop: $(section).offset().top -80
        }, 800);
    });

    window.runInit();

    // Наблюдатель за изменением итоговой суммы корзины (по нажатию +/-/remove)
    setupCartAmountObserver();
});


///////////////
// Vanilla JS:
///////////////

function initCartPageFeatures() {
  // Отображение .delivery-blocks-container при ширине >= 800px
  const container = document.querySelector('.delivery-blocks-container');
  const ro = new ResizeObserver(entries => {
    for (let entry of entries) {
      if (entry.contentRect.width >= 800) {
        container.classList.add('wide');
      } else {
        container.classList.remove('wide');
      }
    }
  });
  ro.observe(container);

  // Расчёт расположение стрелки для блоков tooltips
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.delivery-blocks-container');
    if (!container) return;

    const blocks = container.querySelectorAll('.delivery-block');

    blocks.forEach((block, index) => {
      const tooltip = block.querySelector('.tooltip-content');
      if (!tooltip) return;

      block.addEventListener('mouseenter', () => {
        // Получаем размеры
        const blockRect = block.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        let arrowOffsetX = '50%'; // По умолчанию центр

        // Для первого блока - вычисляем сдвиг стрелки слева
        if (index === 0) {
          // Рассчитываем расстояние между левым краем блока и левым краем тултипа
          let diff = blockRect.left - tooltipRect.left + blockRect.width / 2;
          // Конвертируем пиксели в проценты относительно тултипа
          const percent = (diff / tooltipRect.width) * 100;
          // Ограничиваем в диапазоне от 10% до 50%
          arrowOffsetX = Math.min(Math.max(percent, 10), 50) + '%';
        }
        // Для последнего блока - сдвиг стрелки справа
        else if (index === blocks.length - 1) {
          let diff = tooltipRect.right - blockRect.left - blockRect.width / 2;
          const percent = 100 - (diff / tooltipRect.width) * 100;
          arrowOffsetX = Math.min(Math.max(percent, 50), 90) + '%';
        }

        // Устанавливаем CSS переменную для сдвига стрелки
        tooltip.style.setProperty('--arrow-offset-x', arrowOffsetX);
      });

      block.addEventListener('mouseleave', () => {
        const tooltip = block.querySelector('.tooltip-content');
        if (!tooltip) return;
        tooltip.style.removeProperty('--arrow-offset-x');
      });
    });
  });

  // Работа кнопки readmore ("Details")
  document.querySelectorAll('.product-delivery-data-readmore').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const content = button.nextElementSibling;
      if (content && content.classList.contains('product-delivery-data-hidden')) {
        content.classList.toggle('show');
      }
    });
  });

  // Скролл к элементу по параметру goto
  document.addEventListener('DOMContentLoaded', () => {
  // Получаем параметр goto из URL
    const urlParams = new URLSearchParams(window.location.search);
    const gotoId = urlParams.get('goto');
    if (gotoId) {
      const target = document.getElementById(gotoId);
      if (target) {
      // Позиция элемента относительно документа
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 95; // Отступ сверху

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  });
}

// Вызов функции при условии профиля страницы
if (attilus_config.current_template === 'cart') {
  initCartPageFeatures();
}
